export function slaUnit(value, category) {
	const text = String(value || '');
	if (/days/i.test(text)) return 'days';
	if (/hrs|hours/i.test(text)) return 'hrs';
	return category === 'Reactive' ? 'hrs' : 'days';
}

export function slaDurationMs(value, category) {
	const amount = parseFloat(value);
	if (!Number.isFinite(amount) || amount < 0) return null;
	return slaUnit(value, category) === 'days' ? amount * 86400000 : amount * 3600000;
}

export function formatSla(value, category) {
	if (value === undefined || value === null || value === '') return null;
	const text = String(value).trim();
	if (/hrs|days/i.test(text)) return text;
	return `${text} ${slaUnit(value, category)}`;
}

export function formatDuration(ms) {
	const abs = Math.abs(ms);
	if (abs < 3600000) return `${Math.max(1, Math.round(abs / 60000))} min`;
	if (abs < 48 * 3600000) return `${Math.round(abs / 3600000)} hrs`;
	return `${Math.round(abs / 86400000)} days`;
}

export function getSlaView(item, now = Date.now()) {
	const contract = formatSla(item && item.sla_attend, item && item.category);
	const windowMs = slaDurationMs(item && item.sla_attend, item && item.category);
	const created = item && item.date_created ? new Date(item.date_created).getTime() : NaN;
	if (!windowMs || !Number.isFinite(created)) {
		return { tone: 'ok', label: contract ? `SLA: ${contract}` : null, contract };
	}
	const remainingMs = created + windowMs - now;
	if (remainingMs <= 0) {
		return { tone: 'overdue', label: `${formatDuration(remainingMs)} overdue`, contract };
	}
	const soonMs = Math.min(windowMs * 0.25, slaUnit(item.sla_attend, item.category) === 'days' ? 86400000 : 3600000);
	return {
		tone: remainingMs <= soonMs ? 'soon' : 'ok',
		label: remainingMs <= soonMs ? `${formatDuration(remainingMs)} left` : `SLA: ${contract}`,
		contract,
	};
}

export function formatRelative(value, now = Date.now()) {
	if (!value) return '';
	const created = new Date(value).getTime();
	if (!Number.isFinite(created)) return '';
	const mins = Math.max(0, Math.round((now - created) / 60000));
	if (mins < 1) return 'Just now';
	if (mins < 60) return `${mins}m ago`;
	const hours = Math.round(mins / 60);
	if (hours < 24) return `${hours}h ago`;
	const days = Math.round(hours / 24);
	if (days < 7) return `${days}d ago`;
	return new Date(created).toLocaleDateString(undefined, { day: 'numeric', month: 'short' });
}

export function formatCardStamp(value) {
	if (!value) return { time: '', date: '' };
	const created = new Date(value);
	if (!Number.isFinite(created.getTime())) return { time: '', date: '' };
	const hh = String(created.getHours()).padStart(2, '0');
	const mm = String(created.getMinutes()).padStart(2, '0');
	return {
		time: `${hh}:${mm}`,
		date: created.toLocaleDateString(undefined, { day: 'numeric', month: 'short' }),
	};
}

function refKey(value) {
	return String(value || '').replace(/^#/, '').trim().toLowerCase();
}

export function linkedTasks(card, tasksById = {}, tasksByRef = {}) {
	if (!card) return [];
	const seen = new Set();
	const links = [];

	const add = (id, ref) => {
		const fromId = id ? tasksById[id] : null;
		const fromRef = ref ? tasksByRef[refKey(ref)] : null;
		const task = fromId || fromRef || null;
		const taskId = (task && task.taskId) || id || '';
		const label = taskLabel((task && task.task_ref) || ref);
		const key = taskId || refKey(label);
		if (!key || seen.has(key)) return;
		seen.add(key);
		links.push({ taskId, label: label || 'Task' });
	};

	add(card.taskId, card.task);
	(card.taskIds || []).forEach((item) => {
		if (item && typeof item === 'object') add(item.taskId, item.task || item.task_ref);
		else add(item, null);
	});
	(card.tasks || []).forEach((item) => {
		if (item && typeof item === 'object') add(item.taskId, item.task || item.task_ref);
	});
	return links;
}

export function isUrgentItem(item) {
	if (!item) return false;
	if (String(item.urgent_fault || '').toLowerCase() === 'urgent') return true;
	return /\burgent\b/i.test(item.body || '');
}

export function taskLabel(task) {
	if (!task) return '';
	const text = String(task);
	return text.startsWith('#') ? text : `#${text}`;
}
